module.exports = __webpack_public_path__ + "static/media/8543418864_a125e0d4a1_b.44b93b48.jpg";